import { RealizedCostConfig } from '../../pages/PortfolioOverview/services/kpi/RealizedCostConfig';
import { ProfitableExitsConfig } from './kpis/ProfitableExitsConfig';

export function getClientKpiCalculators() {
  return [new RealizedCostConfig(), new ProfitableExitsConfig()];
}
